

// import React, { useState, useEffect } from "react";
// import { ref, push, set, get } from "firebase/database";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faPhone, faTimes } from "@fortawesome/free-solid-svg-icons";
// import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

// function CTA({ packageDetails }) {
//   const [showSuccess, setShowSuccess] = useState(false);
//   const [showEnquiryForm, setShowEnquiryForm] = useState(false);
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     mobile: '',
//     date: '',
//     travellers: 1,
//     destination: '',
//     packageName: '',
//     duration: '',
//   });

//   // Update form data when packageDetails prop changes
//   useEffect(() => {
//     if (packageDetails) {
//       setFormData(prev => ({
//         ...prev,
//         destination: packageDetails.destination || '',
//         packageName: packageDetails.packageName || '',
//         duration: packageDetails.duration || ''
//       }));
//     }
//   }, [packageDetails]);



// const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     // Prepare the enquiry data
//     const enquiryData = {
//       name: formData.name,
//       email: formData.email,
//       mobile: formData.mobile,
//       travelDate: formData.date,
//       travellers: formData.travellers,
//       packageName: formData.packageName,
//       destination: formData.destination,
//       duration: formData.duration,
//       status: 'new',
//       createdAt: new Date().toISOString()
//     };

//     try {
//       // Get the database instance
//       const { db } = await import('../firebaseConfig');
      
//       // Check if there are existing enquiries for this mobile number
//       const enquiryRef = ref(db, `enquiry/${formData.mobile}`);
//       const snapshot = await get(enquiryRef);
      
//       let srNo = 1;
//       if (snapshot.exists()) {
//         // Count how many enquiries already exist for this mobile
//         const enquiries = snapshot.val();
//         srNo = Object.keys(enquiries).length + 1;
//       }
      
//       // Create a new enquiry with sequential number
//       const newEnquiryRef = ref(db, `enquiry/${formData.mobile}/${srNo}`);
//       await set(newEnquiryRef, enquiryData);
      
//       // Reset form and show success message
//       setFormData({
//         name: '',
//         email: '',
//         mobile: '',
//         date: '',
//         travellers: 1,
//         destination: packageDetails?.destination || '',
//         packageName: packageDetails?.packageName || '',
//         duration: packageDetails?.duration || ''
//       });
      
//       setShowEnquiryForm(false);
//       setShowSuccess(true);
      
//       // Hide success message after 5 seconds
//       setTimeout(() => {
//         setShowSuccess(false);
//       }, 5000);
      
//     } catch (error) {
//       console.error('Error submitting enquiry:', error);
//       alert('There was an error submitting your enquiry. Please try again.');
//     }
//   };
  
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   return (
//     <>
//       <style>
//         {`
//           /* Base styles for all devices */
//           .floating-enquire {
//             position: fixed;
//             right: 24px;
//             top: 83%;
//             background: #64192E;
//             color: #fff;
//             border-radius: 24px;
//             padding: 14px 24px;
//             font-size: 10px;
//             font-weight: 500;
//             border: none;
//             box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
//             z-index: 10;
//             cursor: pointer;
//             display: flex;
//             align-items: center;
//             gap: 10px;
//             transform: translateY(-50%);
//             transition: all 0.3s ease;
//           }
          
//           .floating-enquire:hover {
//             background: #4a1323;
//             transform: translateY(-50%) scale(1.05);
//           }
          
//           .floating-whatsapp {
//             position: fixed;
//             right: 24px;
//             bottom: 32px;
//             background: #25d366;
//             color: #fff;
//             border-radius: 50%;
//             width: 56px;
//             height: 56px;
//             border: none;
//             box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
//             font-size: 2rem;
//             display: flex;
//             align-items: center;
//             justify-content: center;
//             z-index: 10;
//             cursor: pointer;
//             transition: all 0.3s ease;
//           }
          
//           .floating-whatsapp:hover {
//             transform: scale(1.1);
//           }
          
//           .enquiry-modal-overlay {
//             position: fixed;
//             top: 0;
//             left: 0;
//             right: 0;
//             bottom: 0;
//             background: rgba(0, 0, 0, 0.7);
//             display: flex;
//             justify-content: center;
//             align-items: center;
//             z-index: 1000;
//             backdrop-filter: blur(5px);
//           }
          
//           .enquiry-modal {
//             background: white;
//             padding: 30px;
//             border-radius: 16px;
//             width: 90%;
//             max-width: 500px;
//             position: relative;
//             box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
//           }
          
//           .close-modal {
//             position: absolute;
//             top: 15px;
//             right: 15px;
//             background: none;
//             border: none;
//             font-size: 24px;
//             cursor: pointer;
//             color: #64192E;
//             width: 40px;
//             height: 40px;
//             display: flex;
//             align-items: center;
//             justify-content: center;
//             border-radius: 50%;
//             transition: all 0.3s ease;
//           }
          
//           .close-modal:hover {
//             background: #f5f5f5;
//             color: #4a1323;
//           }
          
//           .enquiry-modal h2 {
//             font-size: 1.8rem;
//             color: #64192E;
//             margin-bottom: 10px;
//           }
          
//           .enquiry-modal p {
//             color: #666;
//             margin-bottom: 20px;
//           }
          
//           .enquiry-form {
//             margin-top: 20px;
//           }
          
//           .form-group {
//             margin-bottom: 15px;
//           }
          
//           .form-group label {
//             display: block;
//             margin-bottom: 5px;
//             font-weight: 500;
//             color: #444;
//           }
          
//           .form-group input {
//             width: 100%;
//             padding: 12px 15px;
//             border: 1px solid #ddd;
//             border-radius: 8px;
//             font-size: 1rem;
//             transition: all 0.3s ease;
//           }

// Subodh Rotithor DYP, [24-06-2025 04:22 PM]
// .form-group input:focus {
//             border-color: #64192E;
//             box-shadow: 0 0 0 3px rgba(100, 25, 46, 0.1);
//             outline: none;
//           }
          
//           .readonly-input {
//             background-color: #f5f5f5;
//             cursor: not-allowed;
//           }
          
//           .form-row {
//             display: flex;
//             gap: 15px;
//           }
          
//           .form-row .form-group {
//             flex: 1;
//           }
          
//           .submit-btn {
//             background: #64192E;
//             color: white;
//             border: none;
//             padding: 14px 20px;
//             border-radius: 8px;
//             font-weight: 600;
//             cursor: pointer;
//             width: 100%;
//             margin-top: 10px;
//             font-size: 1.1rem;
//             transition: all 0.3s ease;
//           }
          
//           .submit-btn:hover {
//             background: #4a1323;
//           }
          
//           /* Mobile styles (max-width: 600px) */
//           @media (max-width: 600px) {
//             .floating-enquire {
//               top: auto;
//               bottom: 100px;
//               right: 15px;
//               padding: 12px 20px;
//               font-size: 1rem;
//               border-radius: 20px;
//               transform: none;
//             }
            
//             .floating-whatsapp {
//               right: 15px;
//               bottom: 24px;
//               width: 50px;
//               height: 50px;
//             }
            
//             .enquiry-modal {
//               padding: 20px 15px;
//               width: 95%;
//               max-height: 90vh;
//               overflow-y: auto;
//             }
            
//             .form-row {
//               flex-direction: column;
//               gap: 0;
//             }
            
//             .submit-btn {
//               padding: 14px 20px;
//               font-size: 1rem;
//             }
            
//             .close-modal {
//               top: 10px;
//               right: 10px;
//               font-size: 20px;
//             }
//           }
          
//           /* Tablet styles (768px) */
//           @media (min-width: 601px) and (max-width: 1199px) {
//             .floating-enquire {
//               padding: 14px 22px;
//               font-size: 1.05rem;
//               right: 20px;
//             }
            
//             .floating-whatsapp {
//               right: 20px;
//               width: 54px;
//               height: 54px;
//             }
            
//             .enquiry-modal {
//               width: 85%;
//               max-width: 600px;
//               padding: 25px;
//             }
            
//             .form-row {
//               gap: 10px;
//             }
            
//             .submit-btn {
//               padding: 13px 20px;
//             }
//           }
          
//           /* Laptop/Desktop styles (1200px and above) */
//           @media (min-width: 1200px) {
//             .floating-enquire {
//               transition: all 0.3s ease;
//             }
            
//             .floating-enquire:hover {
//               transform: translateY(-50%) scale(1.05);
//               box-shadow: 0 6px 25px rgba(0, 0, 0, 0.3);
//             }
            
//             .floating-whatsapp {
//               transition: all 0.3s ease;
//             }
            
//             .floating-whatsapp:hover {
//               transform: scale(1.1);
//               box-shadow: 0 6px 25px rgba(0, 0, 0, 0.3);
//             }
            
//             .submit-btn {
//               transition: background 0.3s ease;
//             }
            
//             .close-modal {
//               transition: all 0.3s ease;
//             }
//           }
//            @media (min-width: 400px) {
//             .floating-enquire {
//             position: fixed;
//             background: #64192E;
//             color: #fff;
//             border-radius: 24px;
//             padding: 14px 24px;
//             font-size: 1.1rem;
//             font-weight: 600;
//             border: none;
//             box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
//             z-index: 10;
//             cursor: pointer;
//             display: flex;
//             align-items: center;
//             gap: 10px;
//             transform: translateY(-50%);
//             transition: all 0.3s ease;
//           }
          
//           .floating-enquire:hover {
//             background: #4a1323;
//             transform: translateY(-50%) scale(1.05);
//           }
          
//           .floating-whatsapp {
//             position: fixed;
//             bottom: 32px;
//             background: #25d366;
//             color: #fff;
//             border-radius: 50%;
//             width: 56px;
//             height: 56px;
//             border: none;
//             box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
//             font-size: 2rem;
//             display: flex;
//             align-items: center;
//             justify-content: center;
//             z-index: 10;
//             cursor: pointer;
//             transition: all 0.3s ease;
//           }
          
//           .floating-whatsapp:hover {
//             transform: scale(1.1);
//           }
//             }
//         `}
//       </style>

//       <div>
//         <button
//           className="floating-enquire"
//           onClick={() => setShowEnquiryForm(true)}
//         >
//           <FontAwesomeIcon icon={faPhone} className="text-white" />
//           <span>Enquire Now</span>
//         </button>

//         <button
//           className="floating-whatsapp"
//           onClick={() => window.open(`https://wa.me/917303455505`, "_blank")}
//         >
//           <FontAwesomeIcon icon={faWhatsapp} className="text-white text-2xl" />
//         </button>
        
//         {/* Success Popup */}
//         {showSuccess && (
//           <div style={{
//             position: 'fixed',
//             top: '20px',
//             right: '20px',
//             backgroundColor: '#4BB543',
//             color: 'white',
//             padding: '15px 25px',
//             borderRadius: '8px',
//             boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
//             zIndex: 1000,
//             display: 'flex',
//             alignItems: 'center',
//             gap: '10px',
//             animation: 'slideIn 0.3s ease-out'
//           }}>
//             <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//               <path d="M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z" fill="white"/>
//             </svg>
//             <div>
//               <div style={{fontWeight: '600', marginBottom: '4px'}}>Success!</div>
//               <div style={{fontSize: '14px', opacity: 0.9}}>Your enquiry has been submitted successfully.</div>
//             </div>
//           </div>
//         )}
        
//         {/* Enquiry Form Modal */}
//         {showEnquiryForm && (
//           <div className="enquiry-modal-overlay">
//             <div className="enquiry-modal">
//               <button
//                 className="close-modal"
//                 onClick={() => setShowEnquiryForm(false)}
//               >
//                 <FontAwesomeIcon icon={faTimes} />
//               </button>

//               <h2>Send us a Query</h2>
//               <p>
//                 Ready to venture out into the world? Fill the form below and
//                 start your brand new journey with us
//               </p>

//               <form className="enquiry-form" onSubmit={handleSubmit}>
//                 {/* {packageDetails && (
//                   <div className="form-group" style={{ marginBottom: '20px', padding: '10px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
//                     <h4 style={{ margin: '0 0 10px 0', color: '#64192E' }}>Package Details</h4>
//                     <p style={{ margin: '5px 0', fontSize: '0.9rem' }}><strong>Package:</strong> {packageDetails.packageName}</p>
//                     <p style={{ margin: '5px 0', fontSize: '0.9rem' }}><strong>Destination:</strong> {packageDetails.destination}</p>
//                     {packageDetails.duration && (
//                       <p style={{ margin: '5px 0', fontSize: '0.9rem' }}><strong>Duration:</strong> {packageDetails.duration}</p>
//                     )}
//                   </div>
//                 )} */}

//                 <div className="form-group">
//                   <label>Name*</label>
//                   <input 
//                     type="text" 
//                     name="name"
//                     value={formData.name}
//                     onChange={handleChange}
//                     required 
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label>Email*</label>
//                   <input 
//                     type="email" 
//                     name="email"
//                     value={formData.email}
//                     onChange={handleChange}
//                     required 
//                   />
//                 </div>

//                 <div className="form-row">
//                   <div className="form-group">
//                     <label>Mobile*</label>
//                     <input 
//                       type="tel" 
//                       name="mobile"
//                       value={formData.mobile}
//                       onChange={handleChange}
//                       required 
//                     />
//                   </div>

//                   <div className="form-group">
//                     <label>Travel Date*</label>
//                     <input 
//                       type="date" 
//                       name="date"
//                       value={formData.date}
//                       onChange={handleChange}
//                       required 
//                     />
//                   </div>
//                 </div>

//                 <div className="form-row">
//                   <div className="form-group">
//                     <label>No of travellers*</label>
//                     <input 
//                       type="number" 
//                       name="travellers"
//                       min="1"
//                       value={formData.travellers}
//                       onChange={handleChange}
//                       required 
//                     />
//                   </div>

//                   <div className="form-group">
//                     <label>Destination*</label>
//                     <input 
//                       type="text" 
//                       value={formData.destination || ''} 
//                       readOnly 
//                       className="readonly-input"
//                     />
//                   </div>
//                 </div>

//                 <button type="submit" className="submit-btn">
//                   Submit
//                 </button>
//               </form>
//             </div>
//           </div>
//         )}
//       </div>
//     </>
//   );
// }

// export default CTA;









// import React, { useState, useEffect } from "react";
// import { ref, push, set, get } from "firebase/database";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faPhone, faTimes } from "@fortawesome/free-solid-svg-icons";
// import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

// function CTA({ packageDetails }) {
//   const [showSuccess, setShowSuccess] = useState(false);
//   const [showEnquiryForm, setShowEnquiryForm] = useState(false);
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     mobile: '',
//     date: '',
//     travellers: 1,
//     destination: '',
//     packageName: '',
//     duration: '',
//   });
//   const [isFormValid, setIsFormValid] = useState(false);

//   // Update form data when packageDetails prop changes
//   useEffect(() => {
//     if (packageDetails) {
//       setFormData(prev => ({
//         ...prev,
//         destination: packageDetails.destination || '',
//         packageName: packageDetails.packageName || '',
//         duration: packageDetails.duration || ''
//       }));
//     }
//   }, [packageDetails]);

//   // Validate form whenever formData changes
//   useEffect(() => {
//     const validateForm = () => {
//       const { name, email, mobile, date, travellers, destination } = formData;
//       return (
//         name.trim() !== '' &&
//         email.trim() !== '' &&
//         mobile.trim() !== '' &&
//         date.trim() !== '' &&
//         travellers > 0 &&
//         destination.trim() !== ''
//       );
//     };
    
//     setIsFormValid(validateForm());
//   }, [formData]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     if (!isFormValid) return;
    
//     // Prepare the enquiry data
//     const enquiryData = {
//       name: formData.name,
//       email: formData.email,
//       mobile: formData.mobile,
//       travelDate: formData.date,
//       travellers: formData.travellers,
//       packageName: formData.packageName,
//       destination: formData.destination,
//       duration: formData.duration,
//       status: 'new',
//       createdAt: new Date().toISOString()
//     };

//     try {
//       // Get the database instance
//       const { db } = await import('../firebaseConfig');
      
//       // Check if there are existing enquiries for this mobile number
//       const enquiryRef = ref(db, `enquiry/${formData.mobile}`);
//       const snapshot = await get(enquiryRef);
      
//       let srNo = 1;
//       if (snapshot.exists()) {
//         // Count how many enquiries already exist for this mobile
//         const enquiries = snapshot.val();
//         srNo = Object.keys(enquiries).length + 1;
//       }
      
//       // Create a new enquiry with sequential number
//       const newEnquiryRef = ref(db, `enquiry/${formData.mobile}/${srNo}`);
//       await set(newEnquiryRef, enquiryData);
      
//       // Reset form and show success message
//       setFormData({
//         name: '',
//         email: '',
//         mobile: '',
//         date: '',
//         travellers: 1,
//         destination: packageDetails?.destination || '',
//         packageName: packageDetails?.packageName || '',
//         duration: packageDetails?.duration || ''
//       });
      
//       setShowEnquiryForm(false);
//       setShowSuccess(true);
      
//       // Hide success message after 5 seconds
//       setTimeout(() => {
//         setShowSuccess(false);
//       }, 5000);
      
//     } catch (error) {
//       console.error('Error submitting enquiry:', error);
//       alert('There was an error submitting your enquiry. Please try again.');
//     }
//   };
  
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   return (
//     <>
//       <style>
//         {`
//           /* Base styles for all devices */
//           .floating-enquire {
//             position: fixed;
//             right: 24px;
//             top: 83%;
//             background: #64192E;
//             color: #fff;
//             border-radius: 24px;
//             padding: 14px 24px;
//             font-size: 10px;
//             font-weight: 500;
//             border: none;
//             box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
//             z-index: 10;
//             cursor: pointer;
//             display: flex;
//             align-items: center;
//             gap: 10px;
//             transform: translateY(-50%);
//             transition: all 0.3s ease;
//           }
          
//           .floating-enquire:hover {
//             background: #4a1323;
//             transform: translateY(-50%) scale(1.05);
//           }
          
//           .floating-whatsapp {
//             position: fixed;
//             right: 24px;
//             bottom: 32px;
//             background: #25d366;
//             color: #fff;
//             border-radius: 50%;
//             width: 56px;
//             height: 56px;
//             border: none;
//             box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
//             font-size: 2rem;
//             display: flex;
//             align-items: center;
//             justify-content: center;
//             z-index: 10;
//             cursor: pointer;
//             transition: all 0.3s ease;
//           }
          
//           .floating-whatsapp:hover {
//             transform: scale(1.1);
//           }
          
//           .enquiry-modal-overlay {
//             position: fixed;
//             top: 0;
//             left: 0;
//             right: 0;
//             bottom: 0;
//             background: rgba(0, 0, 0, 0.7);
//             display: flex;
//             justify-content: center;
//             align-items: center;
//             z-index: 1000;
//             backdrop-filter: blur(5px);
//           }
          
//           .enquiry-modal {
//             background: white;
//             padding: 30px;
//             border-radius: 16px;
//             width: 90%;
//             max-width: 500px;
//             position: relative;
//             box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
//           }
          
//           .close-modal {
//             position: absolute;
//             top: 15px;
//             right: 15px;
//             background: none;
//             border: none;
//             font-size: 24px;
//             cursor: pointer;
//             color: #64192E;
//             width: 40px;
//             height: 40px;
//             display: flex;
//             align-items: center;
//             justify-content: center;
//             border-radius: 50%;
//             transition: all 0.3s ease;
//           }
          
//           .close-modal:hover {
//             background: #f5f5f5;
//             color: #4a1323;
//           }
          
//           .enquiry-modal h2 {
//             font-size: 1.8rem;
//             color: #64192E;
//             margin-bottom: 10px;
//           }
          
//           .enquiry-modal p {
//             color: #666;
//             margin-bottom: 20px;
//           }
          
//           .enquiry-form {
//             margin-top: 20px;
//           }
          
//           .form-group {
//             margin-bottom: 15px;
//           }
          
//           .form-group label {
//             display: block;
//             margin-bottom: 5px;
//             font-weight: 500;
//             color: #444;
//           }
          
//           .form-group input {
//             width: 100%;
//             padding: 12px 15px;
//             border: 1px solid #ddd;
//             border-radius: 8px;
//             font-size: 1rem;
//             transition: all 0.3s ease;
//           }
          
//           .form-group input:focus {
//             border-color: #64192E;
//             box-shadow: 0 0 0 3px rgba(100, 25, 46, 0.1);
//             outline: none;
//           }
          
//           .readonly-input {
//             background-color: #f5f5f5;
//             cursor: not-allowed;
//           }
          
//           .form-row {
//             display: flex;
//             gap: 15px;
//           }
          
//           .form-row .form-group {
//             flex: 1;
//           }
          
//           .submit-btn {
//             background: #64192E;
//             color: white;
//             border: none;
//             padding: 14px 20px;
//             border-radius: 8px;
//             font-weight: 600;
//             cursor: pointer;
//             width: 100%;
//             margin-top: 10px;
//             font-size: 1.1rem;
//             transition: all 0.3s ease;
//           }
          
//           .submit-btn:hover:not(:disabled) {
//             background: #4a1323;
//           }
          
//           .submit-btn:disabled {
//             background: #cccccc;
//             cursor: not-allowed;
//             opacity: 0.7;
//           }
          
//           /* Mobile styles (max-width: 600px) */
//           @media (max-width: 600px) {
//             .floating-enquire {
//               top: auto;
//               bottom: 100px;
//               right: 15px;
//               padding: 12px 20px;
//               font-size: 1rem;
//               border-radius: 20px;
//               transform: none;
//             }
            
//             .floating-whatsapp {
//               right: 15px;
//               bottom: 24px;
//               width: 50px;
//               height: 50px;
//             }
            
//             .enquiry-modal {
//               padding: 20px 15px;
//               width: 95%;
//               max-height: 90vh;
//               overflow-y: auto;
//             }
            
//             .form-row {
//               flex-direction: column;
//               gap: 0;
//             }
            
//             .submit-btn {
//               padding: 14px 20px;
//               font-size: 1rem;
//             }
            
//             .close-modal {
//               top: 10px;
//               right: 10px;
//               font-size: 20px;
//             }
//           }
          
//           /* Tablet styles (768px) */
//           @media (min-width: 601px) and (max-width: 1199px) {
//             .floating-enquire {
//               padding: 14px 22px;
//               font-size: 1.05rem;
//               right: 20px;
//             }
            
//             .floating-whatsapp {
//               right: 20px;
//               width: 54px;
//               height: 54px;
//             }
            
//             .enquiry-modal {
//               width: 85%;
//               max-width: 600px;
//               padding: 25px;
//             }
            
//             .form-row {
//               gap: 10px;
//             }
            
//             .submit-btn {
//               padding: 13px 20px;
//             }
//           }
          
//           /* Laptop/Desktop styles (1200px and above) */
//           @media (min-width: 1200px) {
//             .floating-enquire {
//               transition: all 0.3s ease;
//             }
            
//             .floating-enquire:hover {
//               transform: translateY(-50%) scale(1.05);
//               box-shadow: 0 6px 25px rgba(0, 0, 0, 0.3);
//             }
            
//             .floating-whatsapp {
//               transition: all 0.3s ease;
//             }
            
//             .floating-whatsapp:hover {
//               transform: scale(1.1);
//               box-shadow: 0 6px 25px rgba(0, 0, 0, 0.3);
//             }
            
//             .submit-btn {
//               transition: background 0.3s ease;
//             }
            
//             .close-modal {
//               transition: all 0.3s ease;
//             }
//           }
          
//           @media (min-width: 400px) {
//             .floating-enquire {
//               position: fixed;
//               background: #64192E;
//               color: #fff;
//               border-radius: 24px;
//               padding: 14px 24px;
//               font-size: 1.1rem;
//               font-weight: 600;
//               border: none;
//               box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
//               z-index: 10;
//               cursor: pointer;
//               display: flex;
//               align-items: center;
//               gap: 10px;
//               transform: translateY(-50%);
//               transition: all 0.3s ease;
//             }
            
//             .floating-enquire:hover {
//               background: #4a1323;
//               transform: translateY(-50%) scale(1.05);
//             }
            
//             .floating-whatsapp {
//               position: fixed;
//               bottom: 32px;
//               background: #25d366;
//               color: #fff;
//               border-radius: 50%;
//               width: 56px;
//               height: 56px;
//               border: none;
//               box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
//               font-size: 2rem;
//               display: flex;
//               align-items: center;
//               justify-content: center;
//               z-index: 10;
//               cursor: pointer;
//               transition: all 0.3s ease;
//             }
            
//             .floating-whatsapp:hover {
//               transform: scale(1.1);
//             }
//           }
          
//           @keyframes slideIn {
//             from {
//               transform: translateX(100%);
//               opacity: 0;
//             }
//             to {
//               transform: translateX(0);
//               opacity: 1;
//             }
//           }
//         `}
//       </style>

//       <div>
//         <button
//           className="floating-enquire"
//           onClick={() => setShowEnquiryForm(true)}
//         >
//           <FontAwesomeIcon icon={faPhone} className="text-white" />
//           <span>Enquire Now</span>
//         </button>

//         <button
//           className="floating-whatsapp"
//           onClick={() => window.open(`https://wa.me/917303455505`, "_blank")}
//         >
//           <FontAwesomeIcon icon={faWhatsapp} className="text-white text-2xl" />
//         </button>
        
//         {/* Success Popup */}
//         {showSuccess && (
//           <div style={{
//             position: 'fixed',
//             top: '20px',
//             right: '20px',
//             backgroundColor: '#4BB543',
//             color: 'white',
//             padding: '15px 25px',
//             borderRadius: '8px',
//             boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
//             zIndex: 1000,
//             display: 'flex',
//             alignItems: 'center',
//             gap: '10px',
//             animation: 'slideIn 0.3s ease-out'
//           }}>
//             <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//               <path d="M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z" fill="white"/>
//             </svg>
//             <div>
//               <div style={{fontWeight: '600', marginBottom: '4px'}}>Success!</div>
//               <div style={{fontSize: '14px', opacity: 0.9}}>Your enquiry has been submitted successfully.</div>
//             </div>
//           </div>
//         )}
        
//         {/* Enquiry Form Modal */}
//         {showEnquiryForm && (
//           <div className="enquiry-modal-overlay">
//             <div className="enquiry-modal">
//               <button
//                 className="close-modal"
//                 onClick={() => setShowEnquiryForm(false)}
//               >
//                 <FontAwesomeIcon icon={faTimes} />
//               </button>

//               <h2>Send us a Query</h2>
//               <p>
//                 Ready to venture out into the world? Fill the form below and
//                 start your brand new journey with us
//               </p>

//               <form className="enquiry-form" onSubmit={handleSubmit}>
//                 <div className="form-group">
//                   <label>Name*</label>
//                   <input 
//                     type="text" 
//                     name="name"
//                     value={formData.name}
//                     onChange={handleChange}
//                     required 
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label>Email*</label>
//                   <input 
//                     type="email" 
//                     name="email"
//                     value={formData.email}
//                     onChange={handleChange}
//                     required 
//                   />
//                 </div>

//                 <div className="form-row">
//                   <div className="form-group">
//                     <label>Mobile*</label>
//                     <input 
//                       type="tel" 
//                       name="mobile"
//                       value={formData.mobile}
//                       onChange={handleChange}
//                       required 
//                     />
//                   </div>

//                   <div className="form-group">
//                     <label>Travel Date*</label>
//                     <input 
//                       type="date" 
//                       name="date"
//                       value={formData.date}
//                       onChange={handleChange}
//                       required 
//                     />
//                   </div>
//                 </div>

//                 <div className="form-row">
//                   <div className="form-group">
//                     <label>No of travellers*</label>
//                     <input 
//                       type="number" 
//                       name="travellers"
//                       min="1"
//                       value={formData.travellers}
//                       onChange={handleChange}
//                       required 
//                     />
//                   </div>

//                   <div className="form-group">
//                     <label>Destination*</label>
//                     <input 
//                       type="text" 
//                       value={formData.destination || ''} 
//                       readOnly 
//                       className="readonly-input"
//                     />
//                   </div>
//                 </div>

//                 <button 
//                   type="submit" 
//                   className="submit-btn"
//                   disabled={!isFormValid}
//                 >
//                   Submit
//                 </button>
//               </form>
//             </div>
//           </div>
//         )}
//       </div>
//     </>
//   );
// }

// export default CTA;














import React, { useState, useEffect } from "react";
import { ref, push, set, get } from "firebase/database";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faTimes } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

function CTA({ packageDetails }) {
  const [showSuccess, setShowSuccess] = useState(false);
  const [showEnquiryForm, setShowEnquiryForm] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile: '',
    date: '',
    travellers: 1,
    destination: '',
    packageName: '',
    duration: '',
  });
  const [isFormValid, setIsFormValid] = useState(false);

  // Update form data when packageDetails prop changes
  useEffect(() => {
    if (packageDetails) {
      setFormData(prev => ({
        ...prev,
        destination: packageDetails.destination || '',
        packageName: packageDetails.packageName || '',
        duration: packageDetails.duration || ''
      }));
    }
  }, [packageDetails]);

  // Validate form whenever formData changes
  useEffect(() => {
    const validateForm = () => {
      const { name, email, mobile, date, travellers } = formData;
      return (
        name.trim() !== '' &&
        email.trim() !== '' &&
        mobile.trim() !== '' &&
        date.trim() !== '' &&
        travellers > 0
      );
    };
    
    setIsFormValid(validateForm());
  }, [formData]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!isFormValid) return;
    
    // Prepare the enquiry data
    const enquiryData = {
      name: formData.name,
      email: formData.email,
      mobile: formData.mobile,
      travelDate: formData.date,
      travellers: formData.travellers,
      packageName: formData.packageName,
      destination: formData.destination,
      duration: formData.duration,
      status: 'new',
      createdAt: new Date().toISOString()
    };

    try {
      // Get the database instance
      const { db } = await import('../firebaseConfig');
      
      // Check if there are existing enquiries for this mobile number
      const enquiryRef = ref(db, `enquiry/${formData.mobile}`);
      const snapshot = await get(enquiryRef);
      
      let srNo = 1;
      if (snapshot.exists()) {
        // Count how many enquiries already exist for this mobile
        const enquiries = snapshot.val();
        srNo = Object.keys(enquiries).length + 1;
      }
      
      // Create a new enquiry with sequential number
      const newEnquiryRef = ref(db, `enquiry/${formData.mobile}/${srNo}`);
      await set(newEnquiryRef, enquiryData);
      
      // Reset form and show success message
      setFormData({
        name: '',
        email: '',
        mobile: '',
        date: '',
        travellers: 1,
        destination: packageDetails?.destination || '',
        packageName: packageDetails?.packageName || '',
        duration: packageDetails?.duration || ''
      });
      
      setShowEnquiryForm(false);
      setShowSuccess(true);
      
      // Hide success message after 5 seconds
      setTimeout(() => {
        setShowSuccess(false);
      }, 5000);
      
    } catch (error) {
      console.error('Error submitting enquiry:', error);
      alert('There was an error submitting your enquiry. Please try again.');
    }
  };
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <>
      <style>
        {`
          /* Base styles for all devices */
          .floating-enquire {
            position: fixed;
            right: 24px;
            top: 83%;
            background: #64192E;
            color: #fff;
            border-radius: 24px;
            padding: 14px 24px;
            font-size: 10px;
            font-weight: 500;
            border: none;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
            z-index: 10;
            cursor: pointer;
            display: flex;
            align-items: center;
            gap: 10px;
            transform: translateY(-50%);
            transition: all 0.3s ease;
          }
          
          .floating-enquire:hover {
            background: #4a1323;
            transform: translateY(-50%) scale(1.05);
          }
          
          .floating-whatsapp {
            position: fixed;
            right: 24px;
            bottom: 32px;
            background: #25d366;
            color: #fff;
            border-radius: 50%;
            width: 56px;
            height: 56px;
            border: none;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
            font-size: 2rem;
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 10;
            cursor: pointer;
            transition: all 0.3s ease;
          }
          
          .floating-whatsapp:hover {
            transform: scale(1.1);
          }
          
          .enquiry-modal-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.7);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 1000;
            backdrop-filter: blur(5px);
          }
          
          .enquiry-modal {
            background: white;
            padding: 30px;
            border-radius: 16px;
            width: 90%;
            max-width: 500px;
            position: relative;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
          }
          
          .close-modal {
            position: absolute;
            top: 15px;
            right: 15px;
            background: none;
            border: none;
            font-size: 24px;
            cursor: pointer;
            color: #64192E;
            width: 40px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            transition: all 0.3s ease;
          }
          
          .close-modal:hover {
            background: #f5f5f5;
            color: #4a1323;
          }
          
          .enquiry-modal h2 {
            font-size: 1.8rem;
            color: #64192E;
            margin-bottom: 10px;
          }
          
          .enquiry-modal p {
            color: #666;
            margin-bottom: 20px;
          }
          
          .enquiry-form {
            margin-top: 20px;
          }
          
          .form-group {
            margin-bottom: 15px;
          }
          
          .form-group label {
            display: block;
            margin-bottom: 5px;
            font-weight: 500;
            color: #444;
          }
          
          .form-group input {
            width: 100%;
            padding: 12px 15px;
            border: 1px solid #ddd;
            border-radius: 8px;
            font-size: 1rem;
            transition: all 0.3s ease;
          }
          
          .form-group input:focus {
            border-color: #64192E;
            box-shadow: 0 0 0 3px rgba(100, 25, 46, 0.1);
            outline: none;
          }
          
          .readonly-input {
            background-color: #f5f5f5;
            cursor: not-allowed;
          }
          
          .optional-field {
            color: #888;
            font-weight: normal;
          }
          
          .form-row {
            display: flex;
            gap: 15px;
          }
          
          .form-row .form-group {
            flex: 1;
          }
          
          .submit-btn {
            background: #64192E;
            color: white;
            border: none;
            padding: 14px 20px;
            border-radius: 8px;
            font-weight: 600;
            cursor: pointer;
            width: 100%;
            margin-top: 10px;
            font-size: 1.1rem;
            transition: all 0.3s ease;
          }
          
          .submit-btn:hover:not(:disabled) {
            background: #4a1323;
          }
          
          .submit-btn:disabled {
            background: #cccccc;
            cursor: not-allowed;
            opacity: 0.7;
          }
          
          /* Mobile styles (max-width: 600px) */
          @media (max-width: 600px) {
            .floating-enquire {
              top: auto;
              bottom: 100px;
              right: 15px;
              padding: 12px 20px;
              font-size: 1rem;
              border-radius: 20px;
              transform: none;
            }
            
            .floating-whatsapp {
              right: 15px;
              bottom: 24px;
              width: 50px;
              height: 50px;
            }
            
            .enquiry-modal {
              padding: 20px 15px;
              width: 95%;
              max-height: 90vh;
              overflow-y: auto;
            }
            
            .form-row {
              flex-direction: column;
              gap: 0;
            }
            
            .submit-btn {
              padding: 14px 20px;
              font-size: 1rem;
            }
            
            .close-modal {
              top: 10px;
              right: 10px;
              font-size: 20px;
            }
          }
          
          /* Tablet styles (768px) */
          @media (min-width: 601px) and (max-width: 1199px) {
            .floating-enquire {
              padding: 14px 22px;
              font-size: 1.05rem;
              right: 20px;
            }
            
            .floating-whatsapp {
              right: 20px;
              width: 54px;
              height: 54px;
            }
            
            .enquiry-modal {
              width: 85%;
              max-width: 600px;
              padding: 25px;
            }
            
            .form-row {
              gap: 10px;
            }
            
            .submit-btn {
              padding: 13px 20px;
            }
          }
          
          /* Laptop/Desktop styles (1200px and above) */
          @media (min-width: 1200px) {
            .floating-enquire {
              transition: all 0.3s ease;
            }
            
            .floating-enquire:hover {
              transform: translateY(-50%) scale(1.05);
              box-shadow: 0 6px 25px rgba(0, 0, 0, 0.3);
            }
            
            .floating-whatsapp {
              transition: all 0.3s ease;
            }
            
            .floating-whatsapp:hover {
              transform: scale(1.1);
              box-shadow: 0 6px 25px rgba(0, 0, 0, 0.3);
            }
            
            .submit-btn {
              transition: background 0.3s ease;
            }
            
            .close-modal {
              transition: all 0.3s ease;
            }
          }
          
          @media (min-width: 400px) {
            .floating-enquire {
              position: fixed;
              background: #64192E;
              color: #fff;
              border-radius: 24px;
              padding: 14px 24px;
              font-size: 1.1rem;
              font-weight: 600;
              border: none;
              box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
              z-index: 10;
              cursor: pointer;
              display: flex;
              align-items: center;
              gap: 10px;
              transform: translateY(-50%);
              transition: all 0.3s ease;
            }
            
            .floating-enquire:hover {
              background: #4a1323;
              transform: translateY(-50%) scale(1.05);
            }
            
            .floating-whatsapp {
              position: fixed;
              bottom: 32px;
              background: #25d366;
              color: #fff;
              border-radius: 50%;
              width: 56px;
              height: 56px;
              border: none;
              box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
              font-size: 2rem;
              display: flex;
              align-items: center;
              justify-content: center;
              z-index: 10;
              cursor: pointer;
              transition: all 0.3s ease;
            }
            
            .floating-whatsapp:hover {
              transform: scale(1.1);
            }
          }
          
          @keyframes slideIn {
            from {
              transform: translateX(100%);
              opacity: 0;
            }
            to {
              transform: translateX(0);
              opacity: 1;
            }
          }
        `}
      </style>

      <div>
        <button
          className="floating-enquire"
          onClick={() => setShowEnquiryForm(true)}
        >
          <FontAwesomeIcon icon={faPhone} className="text-white" />
          <span>Enquire Now</span>
        </button>

        <button
          className="floating-whatsapp"
          onClick={() => window.open(`https://wa.me/917303455505`, "_blank")}
        >
          <FontAwesomeIcon icon={faWhatsapp} className="text-white text-2xl" />
        </button>
        
        {/* Success Popup */}
        {showSuccess && (
          <div style={{
            position: 'fixed',
            top: '20px',
            right: '20px',
            backgroundColor: '#4BB543',
            color: 'white',
            padding: '15px 25px',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            zIndex: 1000,
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            animation: 'slideIn 0.3s ease-out'
          }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z" fill="white"/>
            </svg>
            <div>
              <div style={{fontWeight: '600', marginBottom: '4px'}}>Success!</div>
              <div style={{fontSize: '14px', opacity: 0.9}}>Your enquiry has been submitted successfully.</div>
            </div>
          </div>
        )}
        
        {/* Enquiry Form Modal */}
        {showEnquiryForm && (
          <div className="enquiry-modal-overlay">
            <div className="enquiry-modal">
              <button
                className="close-modal"
                onClick={() => setShowEnquiryForm(false)}
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>

              <h2>Send us a Query</h2>
              <p>
                Ready to venture out into the world? Fill the form below and
                start your brand new journey with us
              </p>

              <form className="enquiry-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>Name*</label>
                  <input 
                    type="text" 
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required 
                  />
                </div>

                <div className="form-group">
                  <label>Email*</label>
                  <input 
                    type="email" 
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required 
                  />
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Mobile*</label>
                    <input 
                      type="tel" 
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleChange}
                      required 
                    />
                  </div>

                  <div className="form-group">
                    <label>Travel Date*</label>
                    <input 
                      type="date" 
                      name="date"
                      value={formData.date}
                      onChange={handleChange}
                      required 
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>No of travellers*</label>
                    <input 
                      type="number" 
                      name="travellers"
                      min="1"
                      value={formData.travellers}
                      onChange={handleChange}
                      required 
                    />
                  </div>

                  <div className="form-group">
                    <label>Destination <span className="optional-field">(Optional)</span></label>
                    <input 
                      type="text" 
                      name="destination"
                      value={formData.destination}
                      onChange={handleChange}
                      placeholder="Where would you like to go?"
                    />
                  </div>
                </div>

                <button 
                  type="submit" 
                  className="submit-btn"
                  disabled={!isFormValid}
                >
                  Submit
                </button>
              </form>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default CTA;